/* istanbul ignore file */
const loadMockData = () => {
  if (process.env.NODE_ENV === 'production') {
    return Promise.resolve(null);
  }
  return import('./mockData');
};

export default loadMockData;
